// auth.interceptor.ts
import { inject, Injectable } from '@angular/core';
import type { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { JwtService } from '../services/jwt-service.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private jwtService = inject(JwtService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.jwtService.getToken();
    const isS3Presign = req.url.includes('.s3.') || req.url.includes('x-amz-algorithm=');

    if (isS3Presign) {
      const clonedReq = req.clone({
        headers: req.headers.delete('Authorization'),
      });
      return next.handle(clonedReq);
    }

    // A caller that set its own Authorization keeps it — the payslip OTP flow
    // sends a token signed with a different secret than the session's.
    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    if (token) {
      const clonedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
      return next.handle(clonedReq);
    }

    return next.handle(req);
  }
}
